export const PROMO_SUMMARY_TEST_ID = {
  accordian: 'promo-accordian',
};
